import { AxiosError } from "axios";
import { UseQueryOptions, useQuery } from "react-query";

import { IModel, Route } from "@edgetier/watchtower-types";
import { getAllPaginatedItems } from "utilities/get-all-paginated-items";

/**
 * Get the models for a tag.
 * @param url Start URL to get notes.
 */
const getTagModels = async (url: string, parameters = {}) => {
    const models = await getAllPaginatedItems<IModel>(url, { params: parameters });
    return models;
};

/**
 * Get the model which belongs to a tag
 * @param queryId Notes belong to queries. Get the notes for this one.
 * @returns       React Query result.
 */
const useTagModels = <T = IModel[]>(
    tagId: string,
    configuration: UseQueryOptions<IModel[], AxiosError<void>, T> = {}
) => {
    const url = Route.TagModels;
    return useQuery<IModel[], AxiosError<void>, T>([url, tagId], () => getTagModels(url, { tagId }), {
        ...configuration,
    });
};

export default useTagModels;
